import { useState } from 'react';
import '../../App.css';
import './ServicosPage.css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

import unhas        from '../../assets/fotos/unhas.jpg';
import sobrancelhas from '../../assets/fotos/sobrancelhas.jpg';
import depilacao     from '../../assets/fotos/depilacao.jpg';


export default function ServicosPage(){

  return (
    <div className="ServicosPage-container">
        <Header/>

        <article>
            <div className="Servicos">
                <div className="Servicos-alinhamento">
                    <img src={unhas} alt="Unhas" className="Servicos-img"/>
                    <div className="Servicos-texto">
                    <strong>Unhas</strong> <br/>    
                    Com serviços de manicure realizados com dedicação e produtos de alta qualidade, 
                    garantimos o cuidado e a saúde das suas unhas. Nossas técnicas são pensadas para atender 
                    diferentes preferências, desde acabamentos clássicos e discretos até os mais modernos e ousados. 
                    Trabalhamos com esterilização rigorosa de todos os materiais, assegurando segurança e higiene em cada 
                    etapa do atendimento. Além disso, utilizamos esmaltes e produtos de marcas reconhecidas, 
                    que proporcionam brilho, durabilidade e proteção às unhas. 
                    </div>
                </div>
                <div className="Servicos-alinhamento">
                    <div className="Servicos-texto1">
                    <strong>Sobrancelhas</strong> <br/>   
                    Oferecemos serviços especializados para realçar a beleza natural das suas sobrancelhas, 
                    valorizando sua expressão facial. Nossas técnicas incluem design personalizado, alinhado às suas 
                    preferências e ao formato do rosto, garantindo um resultado harmonioso. Utilizamos materiais de alta 
                    qualidade para proporcionar maior conforto e durabilidade nos procedimentos. Além disso, priorizamos 
                    a higiene e segurança, com a esterilização rigorosa de todos os instrumentos utilizados. 
                    Seja para um desenho clássico, preenchimento ou procedimentos modernos, nosso objetivo é realçar sua 
                    confiança e beleza.
                    </div>
                    <img src={sobrancelhas} alt="Sobrancelhas" className="Servicos-img" /> 
                </div>
                <div className="Servicos-alinhamento">
                    <img src={depilacao} alt="Depilação" className="Servicos-img"/>
                    <div className="Servicos-texto">
                    <strong>Depilação</strong> <br/>    
                    Com serviços de depilação realizados com cuidado e técnica especializada,
                    garantimos uma pele lisinha e bem tratada. Nossos procedimentos são adaptados
                    às suas necessidades, oferecendo desde opções tradicionais até métodos mais modernos.
                    Trabalhamos com materiais de alta qualidade e descartáveis, assegurando segurança e higiene
                    em cada etapa do atendimento. Além disso, utilizamos produtos que minimizam irritações,
                    proporcionando conforto e suavidade à pele. Nossa equipe está pronta para oferecer um serviço
                    eficiente e personalizado, pensado para realçar sua beleza e garantir a sua satisfação.
                    </div>
                </div>
            </div>
        </article>
       
        <Footer/>
    </div>
  );  
}